
import { UNDEFINED_VALUE } from '@constants';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IDatesState {
  startDateSelected: string;
  endDateSelected: string;
  startDate: string;
  endDate: string;
  key: string;
  error: string;
  isFocused?: boolean;
}

const initialState: IDatesState = {
  startDateSelected: UNDEFINED_VALUE,
  endDateSelected: UNDEFINED_VALUE,
  startDate: UNDEFINED_VALUE,
  endDate: UNDEFINED_VALUE,
  key: 'selection',
  error: '',
  isFocused: false,
};

const datesSlice = createSlice({
  name: 'dates',
  initialState,
  reducers: {
    setDatesSelected: (
      state: IDatesState,
      { payload }: PayloadAction<{ startDate: string; endDate: string }>,
    ) => {
      state.startDateSelected = payload.startDate;
      state.endDateSelected = payload.endDate;
    },
    setStartDateSelected: (state: IDatesState, { payload }: PayloadAction<string>) => {
      state.startDateSelected = payload;
    },
    setEndDateSelected: (state: IDatesState, { payload }: PayloadAction<string>) => {
      state.endDateSelected = payload;
    },
    setKey: (state: IDatesState, { payload }: PayloadAction<string>) => {
      state.key = payload;
    },
    setError: (state: IDatesState, { payload }: PayloadAction<string>) => {
      state.error = payload;
    },
    setIsFocused: (state: IDatesState, { payload }: PayloadAction<boolean>) => {
      state.isFocused = payload;
    },
    resetDates: (state: IDatesState) => {
      state. startDateSelected = UNDEFINED_VALUE;
      state.endDateSelected = UNDEFINED_VALUE;
      state.startDate = UNDEFINED_VALUE;
      state.endDate = UNDEFINED_VALUE;
      state.key = 'selection';
      state.error = '';
      state.isFocused = false;
    },
    applyDates: (state: IDatesState) => {
      state.startDate = state.startDateSelected;
      state.endDate = state.endDateSelected;
    },
    resetSelectedDates: (state: IDatesState) => {
      state.startDateSelected = state.startDate;
      state.endDateSelected = state.endDate;
    },
  },
});

export const datesActions = datesSlice.actions;

export const datesReducer = datesSlice.reducer;
